import { useTranslation } from 'react-i18next'
import type { OrderStatus } from '../../../shared/utils/orders.js'

const BUTTON_LABEL: Record<string, string> = {
  CONFIRMED: 'orderActions.confirm',
  REJECTED: 'orderActions.reject',
  CANCELLED: 'orderActions.cancel',
  PREPARING: 'orderActions.startPreparing',
  READY: 'orderActions.markReady',
  COMPLETED: 'orderActions.complete',
}

const BUTTON_CLASS: Record<string, string> = {
  CONFIRMED: 'btn btn-primary',
  REJECTED: 'btn btn-danger',
  CANCELLED: 'btn btn-danger',
  PREPARING: 'btn btn-ghost',
  READY: 'btn btn-ghost',
  COMPLETED: 'btn btn-primary',
}

interface Props {
  actions: OrderStatus[]
  pending: boolean
  onAction: (status: OrderStatus) => void
}

export default function OrderActionButtons({ actions, pending, onAction }: Props) {
  const { t } = useTranslation()

  if (actions.length === 0) return null

  return (
    <div className="order-actions">
      {actions.map(status => (
        <button
          key={status}
          type="button"
          className={BUTTON_CLASS[status] ?? 'btn btn-ghost'}
          disabled={pending}
          onClick={() => onAction(status)}
        >
          {t(BUTTON_LABEL[status] ?? 'orderActions.default')}
        </button>
      ))}
    </div>
  )
}